<template>
    <div class="space-y-8">
        <section>
            <div class="mb-6">
                <h3 class="text-md mb-3 font-medium">Button with Menu Trigger</h3>
                <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
                    <div>
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Right aligned trigger element</p>
                        <DsMenu
                            v-model:open="showMenu3"
                            align="end"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsButton
                                    class="w-full md:w-fit"
                                    size="md"
                                    trailing="fa-solid fa-chevron-up"
                                    variant="primary"
                                >
                                    Button CTA
                                </DsButton>
                            </template>
                            <DsMenuGroup label="Keyboard Shortcuts">
                                <DsMenuOption @click="console.log('Copy clicked')">
                                    Copy
                                    <template #trailing>
                                        <span class="text-content-primary">⌘C</span>
                                    </template>
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Paste clicked')">
                                    Paste
                                    <template #trailing>
                                        <span class="text-content-primary">⌘V</span>
                                    </template>
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete clicked')"
                                >
                                    Delete
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div>
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Left aligned trigger element</p>
                        <DsMenu
                            v-model:open="showMenu3Start"
                            align="start"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsButton
                                    class="w-full md:w-fit"
                                    size="md"
                                    trailing="fa-solid fa-chevron-up"
                                    variant="primary"
                                >
                                    Button CTA
                                </DsButton>
                            </template>

                            <DsMenuGroup label="Document Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-file-pdf"
                                    @click="console.log('Edit Document clicked')"
                                >
                                    Edit Document
                                </DsMenuOption>
                                <DsMenuOption
                                    trailing="fa-solid fa-download"
                                    @click="console.log('Download PDF clicked')"
                                >
                                    Download PDF
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete Document clicked')"
                                >
                                    Delete Document
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup>
                                <DsMenuOption
                                    leading="fa-solid fa-cog"
                                    @click="console.log('Settings clicked')"
                                >
                                    Settings
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div>
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Same width trigger element</p>
                        <DsMenu
                            v-model:open="showMenu4"
                            align="end"
                            :fullWidth="true"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsButton
                                    class="w-full"
                                    size="md"
                                    trailing="fa-solid fa-chevron-up"
                                    variant="primary"
                                >
                                    A really long menu trigger
                                </DsButton>
                            </template>
                            <DsMenuGroup label="Document Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-file-pdf"
                                    @click="console.log('Edit Document clicked')"
                                >
                                    Edit Document
                                </DsMenuOption>
                                <DsMenuOption
                                    trailing="fa-solid fa-download"
                                    @click="console.log('Download PDF clicked')"
                                >
                                    Download PDF
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete Document clicked')"
                                >
                                    Delete Document
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup>
                                <DsMenuOption
                                    leading="fa-solid fa-cog"
                                    @click="console.log('Settings clicked')"
                                >
                                    Settings
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="mb-6">
                <h3 class="text-md mb-3 font-medium">Basic Menu - All Strings</h3>
                <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Bottom End</p>
                        <DsMenu
                            v-model:open="showMenu1"
                            align="end"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Bottom End"
                                />
                            </template>
                            <DsMenuGroup label="Document Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-file-pdf"
                                    @click="console.log('Edit Document clicked')"
                                >
                                    Edit Document
                                </DsMenuOption>
                                <DsMenuOption
                                    trailing="fa-solid fa-download"
                                    @click="console.log('Download PDF clicked')"
                                >
                                    Download PDF
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete Document clicked')"
                                >
                                    Delete Document
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup>
                                <DsMenuOption
                                    leading="fa-solid fa-cog"
                                    @click="console.log('Settings clicked')"
                                >
                                    Settings
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Bottom Start</p>
                        <DsMenu
                            v-model:open="showMenu1Start"
                            align="start"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Bottom Start"
                                />
                            </template>
                            <DsMenuGroup label="Document Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-file-pdf"
                                    @click="console.log('Edit Document clicked')"
                                >
                                    Edit Document
                                </DsMenuOption>
                                <DsMenuOption
                                    trailing="fa-solid fa-download"
                                    @click="console.log('Download PDF clicked')"
                                >
                                    Download PDF
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete Document clicked')"
                                >
                                    Delete Document
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup>
                                <DsMenuOption
                                    leading="fa-solid fa-cog"
                                    @click="console.log('Settings clicked')"
                                >
                                    Settings
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Top End</p>
                        <DsMenu
                            v-model:open="showMenu1Top"
                            align="end"
                            side="top"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Top End"
                                />
                            </template>
                            <DsMenuGroup label="Document Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-file-pdf"
                                    @click="console.log('Edit Document clicked')"
                                >
                                    Edit Document
                                </DsMenuOption>
                                <DsMenuOption
                                    trailing="fa-solid fa-download"
                                    @click="console.log('Download PDF clicked')"
                                >
                                    Download PDF
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete Document clicked')"
                                >
                                    Delete Document
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup>
                                <DsMenuOption
                                    leading="fa-solid fa-cog"
                                    @click="console.log('Settings clicked')"
                                >
                                    Settings
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Top Start</p>
                        <DsMenu
                            v-model:open="showMenu1TopStart"
                            align="start"
                            side="top"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Top Start"
                                />
                            </template>
                            <DsMenuGroup label="Document Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-file-pdf"
                                    @click="console.log('Edit Document clicked')"
                                >
                                    Edit Document
                                </DsMenuOption>
                                <DsMenuOption
                                    trailing="fa-solid fa-download"
                                    @click="console.log('Download PDF clicked')"
                                >
                                    Download PDF
                                </DsMenuOption>
                                <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    trailing="fa-solid fa-xmark"
                                    @click="console.log('Delete Document clicked')"
                                >
                                    Delete Document
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup>
                                <DsMenuOption
                                    leading="fa-solid fa-cog"
                                    @click="console.log('Settings clicked')"
                                >
                                    Settings
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>
                </div>
            </div>

            <div class="mb-6">
                <h3 class="text-md mb-3 font-medium">Mixed Menu - Strings + Components</h3>
                <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Bottom End</p>
                        <DsMenu
                            v-model:open="showMenu2"
                            align="end"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Bottom End"
                                />
                            </template>
                            <DsMenuOption
                                leading="fa-solid fa-file-pdf"
                                @click="console.log('Edit Document clicked')"
                            >
                                Edit Document
                            </DsMenuOption>
                            <DsMenuOption
                                trailing="fa-solid fa-pen-to-square"
                                @click="console.log('Custom label clicked')"
                            >
                                <div class="text-ds-blue-600">Custom Blue Label</div>
                            </DsMenuOption>
                            <DsMenuOption @click="console.log('Share Document clicked')">Share Document</DsMenuOption>
                            <DsMenuOption @click="console.log('Delete Document clicked')">
                                <div class="text-ds-red-600">Delete Document</div>
                                <template #trailing>
                                    <DsIcon
                                        class="text-ds-red-500"
                                        icon="fa-solid fa-circle-xmark"
                                        size="sm"
                                    />
                                </template>
                            </DsMenuOption>
                        </DsMenu>
                    </div>

                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Bottom Start</p>
                        <DsMenu
                            v-model:open="showMenu2Start"
                            align="start"
                            side="bottom"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Bottom Start"
                                />
                            </template>
                            <DsMenuOption
                                leading="fa-solid fa-file-pdf"
                                @click="console.log('Edit Document clicked')"
                            >
                                Edit Document
                            </DsMenuOption>
                            <DsMenuOption
                                trailing="fa-solid fa-pen-to-square"
                                @click="console.log('Custom label clicked')"
                            >
                                <div class="text-ds-blue-600">Custom Blue Label</div>
                            </DsMenuOption>
                            <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            <DsMenuOption @click="console.log('Delete Document clicked')">
                                <div class="text-ds-red-600">Delete Document</div>
                                <template #trailing>
                                    <DsIcon
                                        class="text-ds-red-500"
                                        icon="fa-solid fa-xmark"
                                        size="sm"
                                    />
                                </template>
                            </DsMenuOption>
                        </DsMenu>
                    </div>

                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Top End</p>
                        <DsMenu
                            v-model:open="showMenu2Top"
                            align="end"
                            side="top"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Top End"
                                />
                            </template>
                            <DsMenuOption
                                leading="fa-solid fa-file-pdf"
                                @click="console.log('Edit Document clicked')"
                            >
                                Edit Document
                            </DsMenuOption>
                            <DsMenuOption
                                trailing="fa-solid fa-pen-to-square"
                                @click="console.log('Custom label clicked')"
                            >
                                <div class="text-ds-blue-600">Custom Blue Label</div>
                            </DsMenuOption>
                            <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            <DsMenuOption @click="console.log('Delete Document clicked')">
                                <div class="text-ds-red-600">Delete Document</div>
                                <template #trailing>
                                    <DsIcon
                                        class="text-ds-red-500"
                                        icon="fa-solid fa-xmark"
                                        size="sm"
                                    />
                                </template>
                            </DsMenuOption>
                        </DsMenu>
                    </div>

                    <div class="text-center">
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Top Start</p>
                        <DsMenu
                            v-model:open="showMenu2TopStart"
                            align="start"
                            side="top"
                        >
                            <template #menuTrigger>
                                <DsIconButton
                                    icon="fa-solid fa-ellipsis"
                                    size="sm"
                                    tooltipText="Top Start"
                                />
                            </template>
                            <DsMenuOption
                                leading="fa-solid fa-file-pdf"
                                @click="console.log('Edit Document clicked')"
                            >
                                Edit Document
                            </DsMenuOption>
                            <DsMenuOption
                                trailing="fa-solid fa-pen-to-square"
                                @click="console.log('Custom label clicked')"
                            >
                                <div class="text-ds-blue-600">Custom Blue Label</div>
                            </DsMenuOption>
                            <DsMenuOption @click="console.log('Share Document clicked')"> Share Document </DsMenuOption>
                            <DsMenuOption @click="console.log('Delete Document clicked')">
                                <div class="text-ds-red-600">Delete Document</div>
                                <template #trailing>
                                    <DsIcon
                                        class="text-ds-red-500"
                                        icon="fa-solid fa-xmark"
                                        size="sm"
                                    />
                                </template>
                            </DsMenuOption>
                        </DsMenu>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="mb-6">
                <h3 class="text-md mb-3 font-medium">Advanced Examples</h3>
                <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    <div>
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">With Max Height</p>
                        <DsMenu class="max-h-[400px]">
                            <template #menuTrigger>
                                <DsButton
                                    size="md"
                                    variant="primary"
                                >
                                    Open Menu
                                </DsButton>
                            </template>

                            <DsMenuOption @click="console.log('Option 1 clicked')">Option 1</DsMenuOption>
                            <DsMenuOption @click="console.log('Option 2 clicked')">Option 2</DsMenuOption>
                            <DsMenuOption disabled>Disabled Option</DsMenuOption>

                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    leading="fa-solid fa-trash"
                                    variant="destructive"
                                    @click="console.log('Delete clicked')"
                                >
                                    Delete
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div>
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">With Groups</p>
                        <DsMenu>
                            <template #menuTrigger>
                                <DsButton
                                    size="md"
                                    variant="secondary"
                                >
                                    Actions
                                </DsButton>
                            </template>
                            <DsMenuGroup label="File Actions">
                                <DsMenuOption
                                    leading="fa-solid fa-pen-to-square"
                                    @click="console.log('Edit clicked')"
                                >
                                    Edit
                                </DsMenuOption>
                                <DsMenuOption
                                    leading="fa-solid fa-download"
                                    @click="console.log('Download clicked')"
                                >
                                    Download
                                </DsMenuOption>
                            </DsMenuGroup>
                            <DsMenuGroup label="Danger Zone">
                                <DsMenuOption
                                    leading="fa-solid fa-trash"
                                    variant="destructive"
                                    @click="console.log('Delete clicked')"
                                >
                                    Delete
                                </DsMenuOption>
                            </DsMenuGroup>
                        </DsMenu>
                    </div>

                    <div>
                        <p class="mb-2 text-sm font-medium text-ds-primary-600">Custom Content</p>
                        <DsMenu class="max-h-[300px]">
                            <template #menuTrigger>
                                <DsButton
                                    size="md"
                                    variant="primary"
                                >
                                    Custom Menu
                                </DsButton>
                            </template>
                            <DsMenuOption>
                                <template #leading>
                                    <DsIcon
                                        icon="fa-solid fa-circle-question"
                                        size="md"
                                    />
                                </template>
                                Custom Option
                                <template #trailing>
                                    <span class="text-xs">⌘K</span>
                                </template>
                            </DsMenuOption>
                            <DsMenuOption>
                                <template #leading>
                                    <DsIcon
                                        icon="fa-solid fa-circle-question"
                                        size="md"
                                    />
                                </template>
                                Custom Option
                                <template #trailing>
                                    <span class="text-xs">⌘K</span>
                                </template>
                            </DsMenuOption>
                            <DsMenuOption>
                                <template #leading>
                                    <DsIcon
                                        icon="fa-solid fa-circle-question"
                                        size="md"
                                    />
                                </template>
                                Custom Option
                                <template #trailing>
                                    <span class="text-xs">⌘K</span>
                                </template>
                            </DsMenuOption>
                        </DsMenu>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsIconButton from '@/components/design-system/DsIconButton.vue';
import DsButton from '@/components/design-system/form/input/DsButton.vue';
import DsMenu from '@/components/design-system/menu/DsMenu.vue';
import DsMenuGroup from '@/components/design-system/menu/DsMenuGroup.vue';
import DsMenuOption from '@/components/design-system/menu/DsMenuOption.vue';
import { ref } from 'vue';

const showMenu1 = ref(false);
const showMenu2 = ref(false);
const showMenu3 = ref(false);
const showMenu4 = ref(false);
const showMenu1Start = ref(false);
const showMenu1Top = ref(false);
const showMenu1TopStart = ref(false);
const showMenu2Start = ref(false);
const showMenu2Top = ref(false);
const showMenu2TopStart = ref(false);
const showMenu3Start = ref(false);
</script>
